import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import { LocalDate } from "../../Types";
import ValidationError from "../../ZodError";
const DocFile = z.object({
    altInvestmentAssetName: z.string().nullable(),
    baseDirectory: z.string(),
    currentDirectory: z.string().nullable(),
    date: LocalDate,
    fileName: z.string().nullable(),
    fileType: z.string().nullable(),
    parentDirectory: z.string(),
    path: z.string(),
    size: z.number().nullable(),
});
const Response = z.object({
    FartherRecords: DocFile.array().nullable(),
    AlternativeInvestments: DocFile.array().nullable(),
    BusinessOwnership: DocFile.array().nullable(),
    Education: DocFile.array().nullable(),
    EmployerAgreements: DocFile.array().nullable(),
    EstatePlanning: DocFile.array().nullable(),
    InsurancePolicies: DocFile.array().nullable(),
    Leases: DocFile.array().nullable(),
    Other: DocFile.array().nullable(),
    PropertyOwnership: DocFile.array().nullable(),
    Statements: DocFile.array().nullable(),
    Taxes: DocFile.array().nullable(),
    Trusts: DocFile.array().nullable(),
    Vehicles: DocFile.array().nullable(),
});
export const url = () => environment() === "PROD"
    ? `https://middleware.prod.farther.com/custodian-doc/documents/client`
    : `https://middleware.uat.farther.com/custodian-doc/documents/client`;
export default async function getDocuments(clientId, config) {
    const { data } = await axios.get(url(), {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Client: clientId,
            ...(config.advisorId && { Advisor: config.advisorId }),
        },
    });
    const decoded = Response.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = "[getDocuments] Could not parse";
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=getClientDocuments.js.map